import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=551de249&scoped=true&"
import script from "./Audits.vue?vue&type=script&lang=ts&"
export * from "./Audits.vue?vue&type=script&lang=ts&"
import style0 from "./Audits.vue?vue&type=style&index=0&id=551de249&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551de249",
  null
  
)

export default component.exports